<template lang="html">
  <div class="">
    <SiLoaderPopup
      :value="loading && dialog"
      label="Retrieving report..."
    />

    <v-dialog
      v-model="showReport"
      scrollable
      max-width="21cm"
      :fullscreen="$vuetify.breakpoint.xsOnly"
    >
      <v-card>
        <v-card-title
          v-if="$vuetify.breakpoint.xsOnly"
          class="transparent "
        >
          <v-spacer />
          <v-btn
            small
            text
            icon
            color="grey"
            @click="dialog = !dialog"
          >
            <v-icon dark>
              close
            </v-icon>
          </v-btn>
        </v-card-title>
        <div style="overflow: scroll">
          <Report
            v-if="!loading"
            :report="report"
            dialog
          />
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import helpers from '@/mixins/helpers'
import { auth } from '@/plugins/firebase'


export default {
  mixins: [ helpers ],
  props: {
    value: Boolean,
    calculatorId: String,
    calculationId: String
  },
  data () {
    return {
      dialog: false,
      loading: true,
      template: {},
      report: {},
      details: {},
      error: {}
    }
  },
  computed: {
    showReport: {
      get () {
        return this.loading ? false : this.dialog
      },
      set (v) {
        this.dialog = v
      }
    }
  },
  watch: {
    dialog (v) {
      this.$emit('input', v)
      if (v) {
        this.loadReport()
      } else {
        this.reset()
      }
    },
    value (v) {
      this.dialog = v
    }
  },
  mounted () {
  },
  methods: {
    reset () {
      setTimeout(() => {
        this.report = {}
        this.details = {}
        this.template = {}
      }, 500)
    },
    async loadReport () {
      try {
        this.loading = true
        const token = await auth.currentUser.getIdToken()
        const request = await axios.get(`${process.env.VUE_APP_API_URL}/report/${this.calculatorId}/${this.calculationId}/retrieve?admin=true&token=${token}`).then(r => r.data || {})
        let { ...report } = request || {}
        this.loading = false
        this.report = report
        // const { report = {}, details = {}, template = {} } = request
        // this.loading = false
        // this.report = report
        // this.details = details
        // this.template = template
      } catch (error) {
        console.error(error)
        this.loading = false
        this.error = error
      }
    }
  }
}
</script>

<style lang="css" scoped>

</style>
